import { Helper } from "../../core/util/helper";
import { Config } from "../../core/config/config";
import { EmailHelper } from "../emailHelper";
import { StringKeyDictionary } from "../../commonInterfaces";
import React from "react";
export default class ParameterInfo extends React.Component<any, ParameterInfoState>{
    private parameters: {};
    private translations: StringKeyDictionary<string>;
    //private dtIntegral = 0;
    //private dtFloatingPoint = 1;
    private dtString = 2;
    constructor(props) {
        super(props)
        this.initApp();
        this.state = {
            type: props.entity.Type,
            values: []
        }
    }

    private setType = (type: number) => {
        if (this.state.type !== type) {
            this.setState({ values: this.parameters[type], type: type })
        }
    }

    private initApp = async () => {
        let results = await Promise.all([EmailHelper.loadPossibleParameters(), this.loadTranlstaions()]);
        this.parameters = results[0];
        this.translations = results[1];
        this.setState({ values: this.parameters[this.state.type] })
    }

    private loadTranlstaions = (): Promise<StringKeyDictionary<string>> => {
        return new Promise<StringKeyDictionary<string>>(async (resolve) => {
            const key = "email_dataSource_parameter_translations_" + Config.user.languageId;
            let result = Helper.loadDataFromStorage(key);
            if (Helper.hasValue(result)) {
                resolve(result);
            } else {
                Helper.getTranslations([
                    "Standard.Parameter", "WebSMS.Report.Question.Search.Datentyp", "WebCRM.EditIndividualFields.DataType.String", "WebSMS.Report.Question.DataType.int"
                ]).then((result) => {
                    if (result.Code == 0) {
                        Helper.saveDataToStorage(key, result.Data, false);
                        resolve(result.Data)
                    }
                })
            }
        });
    }

    componentDidUpdate() {
        this.setType(this.props.entity.Type);
    }

    render() {
        if (!Helper.hasValue(this.translations)) {
            return null
        } else {
            return (
                <>
                    <table style={{ width: "100%", marginTop: "15px" }}>
                        <tbody>
                            <tr style={{ fontSize: "20px" }}>
                                <th>{this.translations["Standard.Parameter"]}</th>
                                <th>{this.translations["WebSMS.Report.Question.Search.Datentyp"]}</th>
                            </tr>
                            {this.state.values.map((v) => {
                                return (
                                    <React.Fragment key={kendo.guid()}>
                                        <tr>
                                            <td style={{ textAlign: "center", padding: "3px" }}>{v.Name}</td>
                                            <td style={{ textAlign: "center", padding: "3px" }}>{v.TypeKind == this.dtString ? this.translations["WebCRM.EditIndividualFields.DataType.String"] : this.translations["WebSMS.Report.Question.DataType.int"]}</td>
                                        </tr>
                                    </React.Fragment>
                                );
                            })}
                        </tbody>
                    </table>
                </>
            );
        }
    }
}

interface ParameterInfoState {
    values: { Name: string, TypeKind: number }[];
    type: number;
}